import { GLOBAL_SIGN_OUT } from '../constants/metrics';
import { request } from '../utils/apiHelper';

/**
 * The called API will sign the user out by revoking all auth/refresh tokens for that user.
 *
 * @param apiPath Path to the globalSignOut API.
 */
export async function globalSignOut(
  apiPath: string
): Promise<Response | undefined> {
  const response = await request(
    apiPath,
    {
      method: 'GET',
      mode: 'cors',
      headers: {
        'Content-Type': 'application/json',
      },
    },
    { metricNs: GLOBAL_SIGN_OUT, treat404AsOk: true }
  );
  if (response.status === 404) return;
  const result = await response.json();
  return result;
}

export default globalSignOut;
